export type PostImageShareTarget = "copy-image" | "download-image";

async function capturePostImage(card: HTMLElement): Promise<string> {
  const { toPng } = await import("html-to-image");
  await new Promise((resolve) =>
    requestAnimationFrame(() => requestAnimationFrame(resolve)),
  );
  return toPng(card, {
    pixelRatio: 2,
    skipFonts: true,
    filter: (node) =>
      !(node instanceof HTMLElement && node.dataset.shareExclude === "true"),
  });
}

export async function sharePostImage({
  card,
  target,
}: {
  readonly card: HTMLElement;
  readonly target: PostImageShareTarget;
}): Promise<void> {
  if (target === "copy-image") {
    // Clipboard permission requires starting the write during the gesture.
    await navigator.clipboard.write([
      new ClipboardItem({
        "image/png": capturePostImage(card)
          .then((image) => fetch(image))
          .then((response) => response.blob()),
      }),
    ]);
  } else {
    const link = document.createElement("a");
    link.href = await capturePostImage(card);
    link.download = "softmax-post.png";
    link.click();
  }
}
